import React from 'react';
import Helmet from 'react-helmet';
import DangerousHTML from '../../components/DangerousHTML';
import { Link } from '@reach/router';
import Divider from '../../components/Divider';
import { PageContainer, PageBody, PageHeader } from '../../components/Page';
import {withRouteData} from "react-static";

export default withRouteData(({ practiceArea }) => {
  return (<React.Fragment>
    <Helmet title={practiceArea ? practiceArea.title : ''} />
    <PageContainer>
      <PageHeader image={practiceArea ? practiceArea.image : ''} isTruncated />
      <div className="row">
        <div className="col-sm-12 col-md-offset-1 col-md-2 last-xs last-sm first-md first-lg page-sidebar">
          {practiceArea && practiceArea.focusAreas.length > 0 && <h3>Focused Areas</h3>}
          <ul className="list-unstyled">
            {(practiceArea ? practiceArea.focusAreas : []).map((focusArea, focusAreaIndex) => (<li key={focusAreaIndex}>
              {focusArea.body ?
                <a href={`#${focusArea.text.toLowerCase().replace(' ', '-')}`}>{focusArea.text}</a> :
                focusArea.text }
            </li>))}
          </ul>
          <br />
          <h3>Practicing Attorneys</h3>
          <ul className="list-unstyled">
            {(practiceArea ? practiceArea.attorneys : []).map((link, linkIndex) => (<li key={linkIndex}>
              <Link to={link.to}>{link.text}</Link>
            </li>))}
          </ul>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
        </div>
        <PageBody hasSidebar={practiceArea && !!practiceArea.focusAreas}>
          <DangerousHTML html={practiceArea ? practiceArea.body : ''} />
          {(practiceArea ? practiceArea.focusAreas : []).map((focusArea, focusAreaIndex) => {
            if (focusArea.body) {
              return (
                <div key={focusAreaIndex}>
                  <Divider />
                  <a name={focusArea.text.toLowerCase().replace(' ', '-')} />
                  <DangerousHTML key={focusAreaIndex} html={focusArea.body} />
                </div>
              )
            } else {
              return (<div key={focusAreaIndex} />);
            }
          })}
        </PageBody>
      </div>
    </PageContainer>
  </React.Fragment>);
});